import { gql } from '@apollo/client'

export default gql`
    mutation importProducts {
        importProducts
    }
`
